import React, { Component } from 'react';

import LegendValues from '../b-LeafletMap/Legend/LegendValues';
import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendResidentialArea from '../b-LeafletMap/Legend/LegendResidentialArea';

import getMyMap, {createCommuneMassLayer, createGriddedLayer,
                  getLegendMode, createCommuneBordersLayer, createCommunesNamesLayerEasy} from './leaflet_map';

import {c_missing_data, c_gradient_greens, c_gradient_reds} from '../a-Graphic/Colors';

class LeafletMapOrganizationProfile extends React.Component {
  componentDidMount() {
    /* COMMUNES */
    let communes = this.props.territory.communes;
    let communes_coords = communes.map((c) => c.center);
    let communes_names = communes.map((c) => c.name);

    /* POPULATION */
    let communes_pop = communes.map((c) => c.population);
    let communes_pop_label = communes.map((c) => c.name + " - " + c.population + " hab");

    /* DENSITY */
    let communes_density = communes.map((c) => c.corrected_density);
    let communes_density_label = communes.map((c) => c.name + " - " + c.corrected_density + " hab/km² urbanisé");

    /* GRIDDED POPULATION */
    let gridded_population = [].concat(...communes.map((c)=>c.gridded_population));
    let pop_coords = gridded_population.map((c) => c.coords);
    let pop_masses = gridded_population.map((c) => parseInt(c.population));
    let pop_labels = gridded_population.map((c) => c.population + " hab");

    /* GRIDDED POPULATION HH */
    let pop_hh_masses = gridded_population.map((c) => Math.round(c.population/c.households*10)/10);
    let pop_hh_labels = gridded_population.map((c) => Math.round(c.population/c.households*10)/10 + " hab/ménage");

    // --- init map
    let mymap = this.myMap = getMyMap(this.props.id, true, 0.3);

    // --- create layers
    let communes_layer = createCommuneBordersLayer(mymap, communes);
    this.griddedLayer = createGriddedLayer(mymap, pop_coords, pop_masses, pop_labels);
    mymap.removeLayer(this.griddedLayer)
    this.griddedHHLayer = createGriddedLayer(mymap, pop_coords, pop_hh_masses, pop_hh_labels);
    mymap.removeLayer(this.griddedHHLayer)
    this.populationLayer = createCommuneMassLayer(mymap, communes, communes_pop, communes_pop_label);
    mymap.removeLayer(this.populationLayer)
    this.densityLayer = createCommuneMassLayer(mymap, communes, communes_density, communes_density_label);
    mymap.removeLayer(this.densityLayer)
    //createNamesLayer(mymap, communes_coords, communes_names);
    createCommunesNamesLayerEasy(mymap, communes)

    switch (this.props.selected){
      case "corrected_density":
        this.activeLayer = this.densityLayer
        break;
      case "gridded_population":
        this.activeLayer = this.griddedLayer
        break;
      case "gridded_population_hh":
        this.activeLayer = this.griddedHHLayer
        break;
      default:
        this.activeLayer = this.populationLayer
    }

    mymap.addLayer(this.activeLayer)
    // --- center the map
    mymap.fitBounds(this.activeLayer.getBounds());
  }

  componentDidUpdate() {
    this.myMap.removeLayer(this.activeLayer);
    switch (this.props.selected){
      case "corrected_density":
        this.activeLayer = this.densityLayer;
        break;
      case "gridded_population":
        this.activeLayer = this.griddedLayer
        break;
      case "gridded_population_hh":
        this.activeLayer = this.griddedHHLayer
        break;
      default:
        this.activeLayer = this.populationLayer
    }
    this.myMap.addLayer(this.activeLayer)
  }

  render() {
    var communes = this.props.territory.communes;
    switch (this.props.selected){
      case "corrected_density":
        var values = communes.map((c) => c.corrected_density);
        var legend_label = "population (hab/km² urbanisé)"
        break;
      case "gridded_population":
        var gridded_population = [].concat(...communes.map((c)=>c.gridded_population));
        var values = gridded_population.map((c) => parseInt(c.population));
        break;
      case "gridded_population_hh":
        var gridded_population_hh = [].concat(...communes.map((c)=>c.gridded_population));
        var values = gridded_population_hh.map((c) => Math.round(c.population/c.households*10)/10);
        break;
      default:
        var values = communes.map((c) => c.population);
        var legend_label = "population (hab)"
    }
    var [intervals, colors] = getLegendMode("ckmean", values, c_gradient_greens);
    if (this.props.selected == "gridded_population_hh"){
      [intervals, colors] = getLegendMode("gridded_pop_hh", values, c_gradient_reds.slice(0,2).reverse().concat(c_gradient_greens.slice(0,4)));
    }
    return(

        <div className="row align-items-end">

          <div className="col-10">
            <div style={{height: "500px"}} id={this.props.id}></div>
          </div>

          <div className="col-2 pl-0 pr-0">
             {this.props.selected === "gridded_population" ?
               <p><b>Population du carreau</b></p> :
               (this.props.selected === "gridded_population_hh") ?
               <p><b>Taille du ménage au carreau</b> <i>(hab/mén)</i></p> :
               <LegendCommune label={legend_label} />
             }
            <LegendValues intervals={intervals} colors={colors}/>
          </div>
        </div>
    )
  }
}

export default LeafletMapOrganizationProfile;
